// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

import {UPDATE_AVAILABLE, SET_MESSAGE_SHOWN} from '../actions/app'

const initialState = {
  updateAvailable: false,
  messageShown: false
}

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_AVAILABLE:
      return {...state, updateAvailable: action.payload}
    case SET_MESSAGE_SHOWN:
      return {...state, messageShown: action.payload}
    default:
      return state
  }
}
